export default "/_next/static/647b106bd55e075d434cf89497f03b28.png";